import React from 'react';
import classNames from 'classnames';
import {TimeTrackingImportSummaryDto} from '../../../features/time-tracking-import/types';
import styles from '../time-tracking-import.module.scss';

interface TimeTrackingImportSummaryBannerProps {
    summary: TimeTrackingImportSummaryDto;
}

export default function TimeTrackingImportSummaryBanner({
    summary,
}: TimeTrackingImportSummaryBannerProps) {
    return (
        <section
            className={classNames(styles.summaryBanner, {
                [styles.summaryBannerSuccess]: summary.success,
                [styles.summaryBannerError]: !summary.success,
            })}
        >
            <div>
                <h3>{summary.success ? 'Import completed' : 'Import rejected'}</h3>
                <p>
                    {summary.success
                        ? `Shifts: ${summary.importedShifts}, absences: ${summary.importedAbsences}, duplicates skipped: ${summary.skippedDuplicates}${summary.skippedErrors ? `, rows with errors skipped: ${summary.skippedErrors}` : ''}.`
                        : `Errors: ${summary.errorRows}, unresolved rows: ${summary.unresolvedRows}.`}
                </p>
                {!summary.success && summary.globalErrors.length > 0 && (
                    <p>{summary.globalErrors.join(' | ')}</p>
                )}
            </div>
        </section>
    );
}
